import 'whatwg-fetch';
import { httpStatusCodes } from './constants';

function parseJSON(response) {
    if (
        response.status === httpStatusCodes.noContent ||
        response.status === httpStatusCodes.resetContent
    ) {
        return null;
    }

    return response.text();
}

function checkStatus(response) {
    if (
        response.status >= httpStatusCodes.ok &&
        response.status < httpStatusCodes.multipleChoices
    ) {
        return response;
    }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}

export const request = (url, options) => {
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON);
};
